import Hightlighter from 'react-highlight-words';
import * as S from './ChoosePublishers.styled';
import { Checkbox } from 'components';

const Content = ({ foundedPublishers, search, isActive, toggle, isGlobal }) => {
  return foundedPublishers?.map(({ pb_name, pb_number }) => (
    <S.Group key={pb_number}>
      <S.Row>
        <Checkbox
          id={`${pb_number}`}
          isChecked={isActive(pb_number)}
          name={pb_number}
          onChange={toggle}
          isDisabled={isGlobal(pb_number)}
        />
        <S.GroupName onClick={() => !isGlobal(pb_number) && toggle(true, pb_number)}>
          <Hightlighter textToHighlight={pb_name} searchWords={[search]} highlightTag='strong' />
        </S.GroupName>
      </S.Row>
    </S.Group>
  ));
};

export default Content;
